import React from 'react';
import {ModalHeader, Modal, Button, Row, Table, Container} from "react-bootstrap";
import {FormattedMessage} from "react-intl";
import {DocumentEditField} from "./DocumentEditField";
import {FaCircleONotch} from "react-icons/lib/fa";

import DocumentService from "../../services/DocumentService";
import {DocumentSerialNumberManagementField} from "./DocumentSerialNumberManagementField";

//The API service is a self-contained static provider to talk to the certblock api
const documentService = new DocumentService();

/**
 * The SerialNumberManager is visible as the "Auto increment" toggle within the DocumentUploadModal component.
 * Actually it is managing the serial number state. It keeps monitoring desired SerialNumber changes by the
 * DocumentSerialNumberManagementFields and reacts accordingly to update other dependant serialNumbers.
 */
class SerialNumberManager extends React.Component {

	constructor(props) {
		super(props);
	}

}

/**
 * The DocumentUploadModal is a dedicated modal dialog to manage serial numbers and uploaded documents.
 */
export class DocumentUploadModal extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			show: props.show,
			orderPositionData: {
				orderNumber: props.orderNumber,
				deliveryNoteNumber: props.deliveryNoteNumber,
				orderPosition: props.orderPosition,

				documentProfiles: [],
				documents: []
			},
			orderNumber: props.orderNumber,
			deliveryNoteNumber: props.deliveryNoteNumber,
			orderPosition: props.orderPosition,
			positionCount: props.positionCount,
			pendingUploadEventHandler: {},
			pendingDeleteEventHandler: {},
			savingInProgress: false,
			fetchingOrderPositionData: false,
			fetchUpdateCounter: 0,
			closeContainerCallback: props.closeContainerCallback,
			enableSerialNumberManagement: props.enableSerialNumberManagement,
			enableUpload: props.enableUpload
		};
	}

	render() {
		return (
			<Modal animation={false} show={this.state.show}>
				<ModalHeader>
					<Modal.Title>
						{this.state.enableUpload ? <FormattedMessage id="searchDocuments.modalDownloadEditTitle"/> : <FormattedMessage id="searchDocuments.modalDownloadTitle"/>}
						{this.state.orderPositionData?.orderPosition?.name}
					</Modal.Title>
				</ModalHeader>
				<Modal.Body id="modal-download-documents">
					<Container>
						<Row>
							<Table striped="columns">
								<thead>
								<tr>
								</tr>
								</thead>
								<tbody>
								<tr>
									<td><DocumentSerialNumberManagementField
										key={`${this.state.orderNumber}-${this.state.deliveryNoteNumber}-${this.state.orderPosition}-0`}
										entryIndex={0}
										serialNumber={"blubb"}
										/></td>
								</tr>
								</tbody>
							</Table>
						</Row>
					</Container>
				</Modal.Body>
				<Modal.Footer>
					{this.state.fetchingOrderPositionData ? (<>Updating data...&nbsp;&nbsp;<FaCircleONotch className={"spin"}/>&nbsp;&nbsp;</>) : ""}
					{this.state.enableUpload &&
						<Button
							variant={"success"}
							onClick={() => this.savePendingChanges()}>
							<FormattedMessage id="uploadDocuments.modalSerialNumberSaveButton"/>
							{this.state.savingInProgress ? (<>&nbsp;&nbsp;<FaCircleONotch className={"spin"}/></>) : ""}
						</Button>
					}
					<Button
						variant={"danger"}
						onClick={() => this.state.closeContainerCallback()}>
						<FormattedMessage id="uploadDocuments.modalSerialNumberCloseButton"/>
						{this.state.enableUpload ? <>/<FormattedMessage id="uploadDocuments.modalSerialNumberCancelButton"/></> : <></>}
					</Button>
				</Modal.Footer>
			</Modal>
		)
	}

}